var map = {
	"./provider_1x2Gaming_logo.png": 66157,
	"./provider_BB-games_logo.png": 39275,
	"./provider_Blueprint-Gaming_logo.png": 8380,
	"./provider_Booongo_logo.png": 32646,
	"./provider_Cq9_logo.png": 5107,
	"./provider_Dragon-soft_logo.png": 6200,
	"./provider_Evoplay_logo.png": 20381,
	"./provider_Fantasma-Games_logo.png": 64608,
	"./provider_Fugaso_logo.png": 62220,
	"./provider_Gamefish-Global_logo.png": 42382,
	"./provider_Gamzix_logo.png": 55791,
	"./provider_Habanero_logo.png": 69490,
	"./provider_Hacksaw_logo.png": 99028,
	"./provider_Iron-Dog_logo.png": 71607,
	"./provider_Kalamba-Games_logo.png": 57934,
	"./provider_Kiron_logo.png": 96283,
	"./provider_Lady-Luck_logo.png": 93033,
	"./provider_Maverick_logo.png": 8970,
	"./provider_Mobilots_logo.png": 80964,
	"./provider_NetGame_logo.png": 91755,
	"./provider_Netent_logo.png": 19450,
	"./provider_Nolimit-City_logo.png": 24590,
	"./provider_OMI-Gaming_logo.png": 43930,
	"./provider_OneTouch_logo.png": 13923,
	"./provider_Playngo_logo.png": 63683,
	"./provider_Playpearls_logo.png": 22735,
	"./provider_Playson_logo.png": 76000,
	"./provider_Pragmatic-Play_logo.png": 97661,
	"./provider_Print-Studios_logo.png": 91727,
	"./provider_Push-Gaming_logo.png": 74637,
	"./provider_Quickspin_logo.png": 99405,
	"./provider_Red-Tiger_logo.png": 88314,
	"./provider_Relax-Gaming_logo.png": 31412,
	"./provider_Rtg-Slots_logo.png": 46849,
	"./provider_Skywind-Group_logo.png": 93820,
	"./provider_Slotmill_logo.png": 46397,
	"./provider_Spearhead_logo.png": 60897,
	"./provider_Splitrock_logo.png": 67640,
	"./provider_Thunderkick_logo.png": 3050,
	"./provider_Tpg_logo.png": 92742,
	"./provider_Wazdan_logo.png": 29635,
	"./provider_Yggdrasil_logo.png": 43666,
	"./provider_amatic_logo.png": 31917,
	"./provider_apollo_logo.png": 71718,
	"./provider_aristocrat_logo.png": 65837,
	"./provider_ebet_logo.png": 87174,
	"./provider_evolution_logo.png": 82056,
	"./provider_ezugi_logo.png": 96412,
	"./provider_gameart_logo.png": 14632,
	"./provider_greentube_logo.png": 92074,
	"./provider_igrosoft_logo.png": 38627,
	"./provider_igt_logo.png": 92979,
	"./provider_kajot_logo.png": 48949,
	"./provider_konami_logo.png": 87219,
	"./provider_merkur_logo.png": 55605,
	"./provider_microgaming_logo.png": 16192,
	"./provider_playtech_logo.png": 78000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67334;